import React, { memo, useEffect, useCallback, useState} from 'react';
import Step from './Step.js';
import {connect} from 'react-redux';

const Steps = memo(({steps, length, pattern, trackColor, resolution}) => { 
    return steps.map(
              (x) =>
                  <Step
                        key={x.step.id}
                        trackColor={trackColor}
                        pattern={pattern}
                        length={length}
                        stepNumber={x.stepNumber}
                        resolution={resolution}
                        stepData={x.step}/>
    );
});
                  

export default Steps;
